import script from "./AuthenticationExpired.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthenticationExpired.vue?vue&type=script&setup=true&lang=ts"

import "./AuthenticationExpired.vue?vue&type=style&index=0&id=173f396e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-173f396e"]])

export default __exports__